/* eslint-disable */
// import Libs
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import _ from "lodash";
// import TextField from '@material-ui/core/TextField';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import SelectDropdown from '../../../legacy/components/SelectDropdown'

// import custom Components
import ContentWithNavigationSidebar from 'legacy/layouts/ContentWithNavigationSidebar';
import ContentHeader from 'legacy/containers/ContentHeader';
import AccessDeniedContent from 'views/components/AccessDeniedContent/AccessDeniedContent';
import EcgLoader from 'legacy/containers/EcgLoader';
import { UserProfileContext } from 'auth/contexts/UserProfileContext';
import { DATASOURCES, getDataSource } from 'state/services/utils';
import { checkIdtfServiceProviderFeatureEnabled } from 'configs';
import KardiaRxCCTPatientResult from '../../containers/KardiaRxCCTPatientResult';

import {
  getKardiaRxCCTPatientsData,
  handleOnRefreshClick,
  clearPageLimit,
  practiceIdUpdate,
  providerIdUpdate
} from '../../state/KardiaRxCCTPatient/KardiaRxCCTPatientsActions';
import Paginator from '../../components/Table/Paginator';
import KardiaRxPatientCCTSearchBar from '../../containers/KardiaRxPatientCCTSearch/KardiaRxPatientCCTSearchBar';


// import css
import styles from './KardiaRxCCTPatients.css';

/**
 * Page - KardiaRxCCTPatients
 *
 */
class KardiaRxCCTPatients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      perPage: 1000,
      providerValue: null
    };
  }

  componentDidMount() {
    this.props.clearPageLimit();
    this.props.getKardiaRxCCTPatientsData();
  }

  handlePageChange = (page, action = 'click') => {
    this.props.clearPageLimit();
    this.setState(
      {
        currentPage: page,
      },
      () => {
        this.props.getKardiaRxCCTPatientsData(false, 1000, page);
      },
    );
  };

  componentDidUpdate(prevProps){
    const {CCT_PATIENTS_STATE } = this.props;
    const { pageLimit } = CCT_PATIENTS_STATE
    if(pageLimit != prevProps.CCT_PATIENTS_STATE.pageLimit){
      if (pageLimit){
        this.setState({
          perPage: pageLimit,
          currentPage: 1
        })
      } else {
        this.setState({
          perPage: 1000,
          currentPage: 1
        })
      }
    }

  }

  handleRefresh = () => {
    this.setState(
      {
        currentPage: 1,
      },
      () => {
        this.props.refreshData();
      },
    );
  };

  handlePracticeDropdown = (item) => {
    if (item) {
     this.props.practiceIdUpdate(item.team_id)
    } else {
      this.props.practiceIdUpdate(null)
      this.props.providerIdUpdate(null)
      this.setState({
        providerValue: null
      })
      // let InputClear = document.getElementsByClassName('MuiAutocomplete-clearIndicator')[1];
      // if (InputClear) {
      //   InputClear.click();
      // }
    }
    this.props.getKardiaRxCCTPatientsData(false, 1000);
  }

  handleProviderDropdown = (item) => {
    this.setState({
      providerValue: item
    })
    if (item) {
      this.props.providerIdUpdate(item.member_id)
    } else {
      this.props.providerIdUpdate(null)
    }
    this.props.getKardiaRxCCTPatientsData(false, 1000);
  }

  render() {
    const { me, intl, CCT_PATIENTS_STATE } = this.props;
    const totalCount = CCT_PATIENTS_STATE &&
      CCT_PATIENTS_STATE.patients &&
      CCT_PATIENTS_STATE.patients.data[0] &&
      CCT_PATIENTS_STATE.patients.data[0] &&
      CCT_PATIENTS_STATE.patients.data[0].objectCount;
    const recordLenth =
      CCT_PATIENTS_STATE &&
      CCT_PATIENTS_STATE.patients &&
      CCT_PATIENTS_STATE.patients.data[0] &&
      CCT_PATIENTS_STATE.patients.data[0].participants &&
      CCT_PATIENTS_STATE.patients.data[0].participants.length;
    if (!checkIdtfServiceProviderFeatureEnabled(me)) {
      return (
        <ContentWithNavigationSidebar>
          <div
            data-page="kardiaRxCctPatient"
            className={styles.KardiaRxCCTPatientPage}
          >
            <AccessDeniedContent text="Patient" />
          </div>
        </ContentWithNavigationSidebar>
      );
    }
    return (
      <ContentWithNavigationSidebar>
        <div
          data-page="kardiaRxCctPatient"
          className={styles.KardiaRxCCTPatientPage}
        >
          <ContentHeader
            isLoading={me.isFetching}
            showLastRefresh={!me.isFetching}
            lastUpdated={CCT_PATIENTS_STATE.patients.dataLastUpdated}
            handleOnRefreshClick={this.handleRefresh}
            text="Patient"
            me={me}
            showAddPatient={false}
          />
          <React.Fragment>
            <div className={styles.patientSearchBar}>
            <KardiaRxPatientCCTSearchBar/>
          <div className={styles.KardiaRxCctSecondaryFilter}>
                {/* <Autocomplete
                  id="combo-box-patient-practice"
                  options={_.uniqBy(this.props.patientPracticeAutoCompleteSearch, function (e) {
                    return e.team_id;
                  })}                  
                  getOptionLabel={(option) => option.teamName}
                  style={{ width: '47%' }}
                  onChange={this.handlePracticeDropdown}
                  renderInput={(params) => <TextField {...params} variant="standard" size="small" placeholder="Practice Name" variant="outlined" />}
                /> */}
                <div style={{width:'47%'}}>
                 <SelectDropdown
                        isClearable={true}
                        backspaceRemovesValue={true}
                        placeholder="Practice Name"
                        options={_.uniqBy(this.props.patientPracticeAutoCompleteSearch, function (e) {
                          return e.team_id;
                        })}  
                        onChange={this.handlePracticeDropdown}
                        noOptionsMessage="No Practice found"
                        getOptionLabel={(option) => option.teamName}
                        getOptionValue={p => p.team_id}
                        className="practiceSelect react-select-filter-selector"
                      />
                </div>
                <div style={{width:'47%'}}>
                 <SelectDropdown
                        disabled={this.props.practiceId ? false : true}
                        isClearable={true}
                        backspaceRemovesValue={true}
                        placeholder="Provider Name"
                        value={this.state.providerValue}
                        options={_.uniqBy(this.props.patientProviderAutoCompleteSearch, function (e) {
                          return e.member_id;
                        })} 
                        onChange={this.handleProviderDropdown}
                        noOptionsMessage="No Provider found"
                        getOptionLabel={(option) => option.name}
                        getOptionValue={p => p.member_id}
                        className="providerSelect react-select-filter-selector"
                      />
                </div>
                {/* <Autocomplete
                  id="combo-box-patient-provider"
                  disabled={this.props.practiceId ? false : true}
                  options={_.uniqBy(this.props.patientProviderAutoCompleteSearch, function (e) {
                    return e.member_id;
                  })}                  // inputValue="sumit"
                  getOptionLabel={(option) => option.name}
                  style={{ width: '47%' }}
                  onChange={this.handleProviderDropdown}
                  renderInput={(params) => <TextField {...params} variant="standard" size="small" placeholder="Provider Name" variant="outlined" />}
                /> */}
              </div>
            </div>
            <div className={styles.KardiaRxCCTPatientContainer}>
              <div className={styles.kardiaPaginator}>
                <div style={{ marginLeft: 20 }}>
                  {' '}
                  SHOWING {recordLenth} OF {totalCount}{' '}
                </div>
                <div style={{ marginBottom: 5 }}>
                  <Paginator
                    isLoading={CCT_PATIENTS_STATE.patients.isFetching}
                    currentPage={this.state.currentPage}
                    perPage={this.state.perPage}
                    totalRecords={
                      CCT_PATIENTS_STATE.patients &&
                      CCT_PATIENTS_STATE.patients.data[0] &&
                      CCT_PATIENTS_STATE.patients.data[0] &&
                      CCT_PATIENTS_STATE.patients.data[0].objectCount
                    }
                    onPageChange={this.handlePageChange}
                  />
                </div>
              </div>
              {CCT_PATIENTS_STATE.patients.isFetching ? (
                <EcgLoader />
              ) : (
                <KardiaRxCCTPatientResult {...this.props}/>
              )}
            </div>
          </React.Fragment>
        </div>
      </ContentWithNavigationSidebar>
    );
  }
}

KardiaRxCCTPatients.contextType = UserProfileContext;
const mapStateToProps = state => {
  const me = getDataSource(state, DATASOURCES.ME);
  const CCT_PATIENTS_STATE = state.kardiaRx.kardiaRxCCTPatients;
  const patientPracticeAutoCompleteSearch = state.kardiaRx.kardiaRxCCTPatients.patientPracticeAutoCompleteSearch;
  const patientProviderAutoCompleteSearch = state.kardiaRx.kardiaRxCCTPatients.patientProviderAutoCompleteSearch;
  const practiceId = state.kardiaRx.kardiaRxCCTPatients.practiceId;

  return {
    me,
    CCT_PATIENTS_STATE,
    patientPracticeAutoCompleteSearch,
    patientProviderAutoCompleteSearch,
    practiceId,
  };
};

const mapActionCreators = {
  getKardiaRxCCTPatientsData,
  refreshData: handleOnRefreshClick,
  clearPageLimit,
  practiceIdUpdate,
  providerIdUpdate,
};
export default connect(
  mapStateToProps,
  mapActionCreators,
)(injectIntl(KardiaRxCCTPatients));



// WEBPACK FOOTER //
// ./src/views/pages/KardiaRxCCTPatients/KardiaRxCCTPatients.jsx